import { createContext, useContext, useState } from "react";

// Create Context
const AppointmentContext = createContext();
export const useAppointment = () => {
  return useContext(AppointmentContext);
};
// Provider Component
const AppointmentProvider = ({ children }) => {
  const [prefillData, setPrefillData] = useState(null);
  const [appointmentData, setAppointmentData] = useState(false);
  const handleAppointment = (data=null) => {
    setPrefillData(data);
    setAppointmentData(!appointmentData);
  };

  return (
    <AppointmentContext.Provider
      value={{ appointmentData, setAppointmentData, handleAppointment,prefillData }}
    >
      {children}
    </AppointmentContext.Provider>
  );
};

export default AppointmentProvider;
